import A2UIPreviewPage, { type A2UIPreviewCopy } from './A2UIPreviewPage';

export default function A2UIPreviewWorkbenchPage({ initialRaw, monacoSsrHtml, copy, documentKey = 'preview:default' }: { initialRaw: string; monacoSsrHtml?: string; copy: A2UIPreviewCopy; documentKey?: string }) {
  return (
    <section className="flex h-full min-h-0 w-full min-w-0 flex-col py-1">
      <div className="min-h-0 min-w-0 flex-1 overflow-visible">
        <A2UIPreviewPage initialRaw={initialRaw} monacoSsrHtml={monacoSsrHtml} copy={copy} layout="embedded" className="h-full" documentKey={documentKey} />
      </div>
    </section>
  );
}
